import { Link } from 'react-router-dom';

export default function NotFoundScreen() {
  return (
    <section style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <p style={{ letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--color-gold-champagne)', fontSize: 12 }}>Legacy Architect</p>
        <h1 style={{ fontSize: 28, marginTop: 8 }}>This page doesn't exist.</h1>
        <p style={{ color: 'var(--color-text-secondary)' }}>
          <Link to="/" className="la-link">Return to your vault</Link>
        </p>
      </div>
    </section>
  );
}
